import { api, mediaRaw } from "@/lib/api";

const unwrap = (p) => p.then((r) => r.data);

export const adminApi = {
  // solutions
  listSolutions: () => unwrap(api.get("/solutions")),
  createSolution: (b) => unwrap(api.post("/solutions", b)),
  updateSolution: (id, b) => unwrap(api.put(`/solutions/${id}`, b)),
  solutionStatus: (id, status) => unwrap(api.patch(`/solutions/${id}/status`, { status })),
  reorderSolutions: (ids) => unwrap(api.post("/solutions/reorder", { ordered_ids: ids })),
  deleteSolution: (id) => unwrap(api.delete(`/solutions/${id}`)),
  // industries
  listIndustries: () => unwrap(api.get("/industries")),
  createIndustry: (b) => unwrap(api.post("/industries", b)),
  updateIndustry: (id, b) => unwrap(api.put(`/industries/${id}`, b)),
  industryStatus: (id, status) => unwrap(api.patch(`/industries/${id}/status`, { status })),
  reorderIndustries: (ids) => unwrap(api.post("/industries/reorder", { ordered_ids: ids })),
  deleteIndustry: (id) => unwrap(api.delete(`/industries/${id}`)),
  // media
  listMedia: (kind, q) => unwrap(api.get("/media", { params: { kind, q } })),
  uploadMedia: (file, title, description, onProgress) => {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("title", title || "");
    fd.append("description", description || "");
    return unwrap(api.post("/media", fd, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (e) => onProgress && onProgress(Math.round((e.loaded / (e.total || 1)) * 100)),
    }));
  },
  updateMediaMeta: (id, title, description) => {
    const fd = new FormData();
    fd.append("title", title);
    fd.append("description", description || "");
    return unwrap(api.put(`/media/${id}`, fd, { headers: { "Content-Type": "multipart/form-data" } }));
  },
  deleteMedia: (id, force) => unwrap(api.delete(`/media/${id}`, { params: { force } })),
  // settings
  getSetting: (key) => unwrap(api.get(`/settings/${key}`)),
  updateSetting: (key, value) => unwrap(api.put(`/settings/${key}`, value)),
  emailStatus: () => unwrap(api.get("/settings/email/status")),
  // analytics
  dashboard: (start, end) => unwrap(api.get("/analytics/dashboard", { params: { start, end } })),
  events: (start, end) => unwrap(api.get("/analytics/events", { params: { start, end } })),
  deliveries: () => unwrap(api.get("/analytics/deliveries")),
  leads: () => unwrap(api.get("/analytics/leads")),
  // users
  listUsers: () => unwrap(api.get("/auth/users")),
  createUser: (b) => unwrap(api.post("/auth/users", b)),
  updateUser: (id, b) => unwrap(api.put(`/auth/users/${id}`, b)),
  deleteUser: (id) => unwrap(api.delete(`/auth/users/${id}`)),
};

export async function downloadCsv(path, filename) {
  const res = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export { mediaRaw };
